import { Button } from '@factorialco/deprecated-design-system'
import {
  PayrollRunInfoPayrollRunFragment,
  TogglePayrollRunLockDocument,
} from 'generated/resources/graphql'
import { CompensationsPayrollRunDocument } from 'generated/resources/graphql'
import { CycleRouteMetaDocument } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useMutation } from 'modules/core/hooks/useMutation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { stringToDate } from 'modules/core/lib/dates'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

type PayrollRunInfoProps = PayrollRunInfoPayrollRunFragment
interface TogglePayrollRunLockModalProps {
  payrollRun: PayrollRunInfoProps
  lock: boolean
  onSuccess: () => void
  onClose: () => void
}

const TogglePayrollRunLockModal = ({
  payrollRun,
  onSuccess,
  onClose,
  lock,
}: TogglePayrollRunLockModalProps) => {
  const [togglePayrollRunLock] = useMutation(TogglePayrollRunLockDocument, {
    extractorFn: (result) => result.compensationsMutations.toggleLockCompensationsPayrollRun,
  })

  const onSubmit = async () => {
    const result = await togglePayrollRunLock({
      variables: {
        lock,
        payrollRunId: payrollRun.id,
      },
      refetchQueries: [CompensationsPayrollRunDocument, CycleRouteMetaDocument],
    })

    if (lock) {
      track(trackingEvents.compensations.lockPayrollRun, {
        payrollRunId: payrollRun.id,
      })
    } else {
      track(trackingEvents.compensations.unlockPayrollRun, {
        payrollRunId: payrollRun.id,
      })
    }

    const handled = handleResult(result, () => undefined)

    if (handled.success && handled.data.payrollRun) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.saved_successfully'),
      })

      onSuccess()
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('common.error'),
      })
    }

    return handled
  }

  // FIXME: Once i18nDateToString is ressurected move the format to the i18n translations
  const formatedStartsOn = stringToDate(payrollRun.startsOn, 'backend_datetime').format('MMMM YYYY')

  const title = lock
    ? i18n.t('compensations.PayrollRunCompensationsList.lock_modal_lock_title', {
        period: formatedStartsOn,
      })
    : i18n.t('compensations.PayrollRunCompensationsList.lock_modal_unlock_title', {
        period: formatedStartsOn,
      })
  const description = lock
    ? i18n.t('compensations.PayrollRunCompensationsList.lock_modal_lock_description')
    : i18n.t('compensations.PayrollRunCompensationsList.lock_modal_unlock_description')

  return (
    <Modal
      illustration="permissions"
      title={title}
      description={description}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button submit>{i18n.t('common.confirm')}</Button>
        </>
      }
    ></Modal>
  )
}

export default TogglePayrollRunLockModal
